import React, { Component } from 'react';

import './Footer.css';

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gym: this.props.gym
    }
  }

  cheatingTimeDifference(date) {

    let dateobj = new Date(date * 1000);
    if(dateobj === 'Invalid Date') return;

    let seconds = Math.floor((new Date() - dateobj) / 1000);

    let interval = Math.floor(seconds / 31536000);

    if (interval > 1) {
      return interval + " years";
    }
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
      return interval + " months";
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
      return interval + " days";
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
      return interval + " hours";
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
      return interval + " minutes";
    }
    return Math.floor(seconds) + " seconds";
  }

  componentDidMount() {
    if(!this.props.gym) return;
    this.setState({
      date: this.props.gym.updated_at,
      code: this.props.gym.invite_code,
      gymName: this.props.gym.display_name,
      gym_pays_membership: this.props.gym.gym_pays_membership
    });
  }

  componentDidUpdate() {
    if(!this.props.gym) return;

    if(this.state.date === this.props.gym.updated_at) return;
    this.setState({
      date: this.props.gym.updated_at,
      code: this.props.gym.invite_code,
      gymName: this.props.gym.display_name,
      gym_pays_membership: this.props.gym.gym_pays_membership
    });
  }

  render() {
    return(
      <footer className="pa4 mt6">
        <p className="f6 b tc">Sign up at: btwb.com/signup with code {this.state.code}</p>
        <p className="f6 tc">
          © 2009-2020 All rights reserved.
        </p>
        <p className="f6 tc">
          CrossFit® is a trademark of CrossFit, Inc. in the U.S. and/or other countries. Used with permission.
        </p>
        <p className="f6 tc">
          Real CrossFitters read the <a href="https://journal.crossfit.com">CrossFit Journal</a>, and keep up with the <a href="https://games.crossfit.com">CrossFit Games</a>.
        </p>
      </footer>
    );
  }
}

export default Footer;